import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { UserService } from '../../../layout/service/user.service';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
    selector: 'app-preview',
    imports: [
        ButtonModule,
        TableModule,
        CommonModule,
        InputTextModule,
        ToastModule,
        DialogModule,
        EditorModule,
        FormsModule,
        CheckboxModule,
        ConfirmDialogModule
    ],
    providers: [
        ConfirmationService,
        MessageService
    ],
    template: `
        <p-toast />
        <p-confirmdialog />
        <p-dialog header="Tambah Skema" [(visible)]="showDialog" [modal]="true" [closable]="false" [style]="{ width: '50vw' }" position="top" [draggable]="false" >
            <div>
                <p-editor [(ngModel)]="newSceneContent" id="editor" [style]="{ height: '220px' }"></p-editor>
            </div>
            <div class="mt-3">
                <div class="flex items-center gap-1">
                    <p-checkbox [(ngModel)]="isSubHeader" binary="true" />
                    <label class="ml-2">Centang bagian ini jika ini merupakan bagian sub judul</label>
                </div>
            </div>
            <div class="flex justify-end mt-3">
                <p-button label="Batal" icon="pi pi-times" severity="secondary" (click)="closeDialog()" class="mr-2"></p-button>
                <p-button label="Simpan" icon="pi pi-check" (click)="saveScene()" ></p-button>
            </div>
        </p-dialog>
        <div class="card">
            <div class="flex justify-between items-center">
                <h3 class="text-primary font-bold">Pratinjau Formulir</h3>
                <p-button severity="success" label="Tambah Skena" icon="pi pi-plus" (click)="openDialog()"></p-button>
            </div>
            <hr>
            <h5 class="mt-0">Judul : {{ results.TITLE }}</h5>
            <h5 class="mt-0">Kategori : {{ results.KATEGORI }}</h5>
            <hr>
            <p-table [value]="forms" showGridlines [loading]="loading" [tableStyle]="{ 'min-width': '50rem' }" reorderableRows (onRowReorder)="onRowReorder($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="w-10 text-center" rowspan="2">#</th>
                        <th class="w-10 text-center" rowspan="2">No</th>
                        <th rowspan="2">Kegiatan</th>
                        <th colspan="4" class="text-center">Skor</th>
                        <th class="w-40 text-center" rowspan="2"></th>
                    </tr>
                    <tr>
                        <th class="text-center">0</th>
                        <th class="text-center">1</th>
                        <th class="text-center">2</th>
                        <th class="text-center">3</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-form let-i="rowIndex">
                    <tr *ngIf="form.IS_HEADER === '1'" [pReorderableRow]="i">
                        <td>
                            <span class="pi pi-sort" pReorderableRowHandle></span>
                        </td>
                        <td colspan="6" class="font-bold text-center bg-primary text-white" [innerHTML]="sanitizeHtml(form.ACTIVITY)"></td>
                        <td class="">
                            <p-button icon="pi pi-pencil" variant="text" [raised]="true" severity="warn" class="mr-2" (click)="openDialog(form)"></p-button>
                            <p-button icon="pi pi-trash" variant="text" [raised]="true" severity="danger" class="mr-2" (click)="onDelete($event, form)"></p-button>
                        </td>
                    </tr>
                    <tr *ngIf="form.IS_HEADER === '0'" [pReorderableRow]="i">
                        <td>
                            <span class="pi pi-sort" pReorderableRowHandle></span>
                        </td>
                        <td class="text-center">{{ form.NO }}</td>
                        <td [innerHTML]="sanitizeHtml(form.ACTIVITY)"></td>
                        <td class="text-center">
                            <input disabled type="radio" name="score-{{ form.NO }}" value="0" />
                        </td>
                        <td class="text-center">
                            <input disabled type="radio" name="score-{{ form.NO }}" value="1" />
                        </td>
                        <td class="text-center">
                            <input disabled type="radio" name="score-{{ form.NO }}" value="2" />
                        </td>
                        <td class="text-center">
                            <input disabled type="radio" name="score-{{ form.NO }}" value="3" />
                        </td>
                        <td class="">
                            <p-button icon="pi pi-pencil" variant="text" [raised]="true" severity="warn" class="mr-2" (click)="openDialog(form)"></p-button>
                            <p-button icon="pi pi-trash" variant="text" [raised]="true" severity="danger" class="mr-2" (click)="onDelete($event, form)"></p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    `
})
export class Preview implements OnInit {

    results: any = {
        ID_OSCE: "",
        TITLE: "",
        SKDI: "",
        ID_KATEGORI: "",
        CREATED_AT: "",
        CREATED_BY: "",
        IS_ACTIVED: "",
        KATEGORI: ""
    };

    details: any;

    forms: any[] = [];

    showDialog: boolean = false;
    newSceneContent: string = '';
    isSubHeader: boolean = false;
    selectedScene: any = null;
    loading: boolean = true;

    constructor(
        private confirmationService: ConfirmationService,
        private userService: UserService,
        private sanitizer: DomSanitizer,
        private messageService: MessageService
    ) {}

    ngOnInit(): void {
        const storedResults = localStorage.getItem('results');
        this.results = storedResults ? JSON.parse(storedResults) : this.results;

        this.userService.getOsceDetail(this.results).then((response) => {
            this.details = response.data;

            this.forms = this.details.FORM;

            this.loading = false;

        });
    }

    sanitizeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    onRowReorder(event: any): void {
        const updatePromises = this.forms.map((item: any, index: number) => {
            item.NO = index + 1;
            return this.userService.updateOsceDetail({
                item
            });
        });

        Promise.all(updatePromises)
            .then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Urutan formulir berhasil diperbarui'
                });
            })
            .catch(() => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Gagal',
                    detail: 'Gagal memperbarui urutan formulir'
                });
            });
    }

    openDialog(scene: any = null): void {
        this.showDialog = true;
        if (scene) {
            this.selectedScene = scene;
            this.newSceneContent = scene.ACTIVITY;
            this.isSubHeader = scene.IS_HEADER === '1';
        } else {
            this.selectedScene = null;
            this.newSceneContent = '';
            this.isSubHeader = false;
        }
    }

    closeDialog(): void {
        this.showDialog = false;
        this.selectedScene = null;
    }

    saveScene(): void {
        if (this.selectedScene) {

            this.selectedScene.ACTIVITY = this.newSceneContent;
            this.selectedScene.IS_HEADER = this.isSubHeader ? '1' : '0';
            this.selectedScene.UPDATED_BY = this.results.CREATED_BY;

            this.userService.updateOsceDetail([this.selectedScene]).then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Skena berhasil diperbarui'
                });
                this.closeDialog();
            }).catch(() => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Gagal',
                    detail: 'Gagal memperbarui skena'
                });
            });
        } else {

            const newScene = {
                ACTIVITY: this.newSceneContent,
                IS_HEADER: this.isSubHeader ? '1' : '0',
                NO: this.forms.length + 1,
                ID_OSCE: this.results.ID_OSCE,
                CREATED_BY: this.results.CREATED_BY
            };

            this.userService.addOsceDetail(newScene).then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Skena baru berhasil ditambahkan'
                });
                this.closeDialog();
                this.ngOnInit();
            }).catch(() => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Gagal',
                    detail: 'Gagal menambahkan skena baru'
                });
            });
        }
    }

    onDelete(event: Event, form: any): void {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Apakah Anda yakin ingin menghapus data ini?',
            header: 'Zona Bahaya',
            icon: 'pi pi-info-circle',
            rejectLabel: 'Batal',
            rejectButtonProps: {
                label: 'Batal',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Hapus',
                severity: 'danger',
            },

            accept: () => {
                this.userService.deleteOsceDetail(
                    { ID_DETAIL_OSCE: form.ID_DETAIL_OSCE }
                ).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Berhasil', detail: 'Formulir berhasil dihapus' });
                    this.ngOnInit();
                }).catch(() => {
                    this.messageService.add({ severity: 'error', summary: 'Gagal', detail: 'Gagal menghapus formulir' });
                })
            },
            reject: () => {
                this.messageService.add({ severity: 'error', summary: 'Ditolak', detail: 'Anda membatalkan aksi' });
            },
        });
    }
}
